<template>
  <div>
    <Head :title="title" />
    <div class="mb-8 flex justify-start max-w-full flex-wrap">
      <h1 class="font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.portal-announcements.index')">
          Portal Pengumuman
        </inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ title }}
      </h1>
    </div>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-4xl">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.title"
            :error="form.errors.title"
            class="pr-6 pb-8 w-full"
            label="Judul"
            required />
          <select-input
            v-model="form.portal_status"
            :error="form.errors.portal_status"
            class="pr-6 pb-8 w-full md:w-1/4"
            label="Status Portal"
            required>
            <option value="open">
              Open
            </option>
            <option value="closed">
              Closed
            </option>
          </select-input>
          <div class="pr-6 pb-8 w-full md:w-1/4 flex items-center pt-6">
            <label class="flex items-center">
              <input
                v-model="form.is_active"
                type="checkbox"
                class="form-checkbox">
              <span class="ml-2">Aktif</span>
            </label>
          </div>
          <text-input
            v-model="form.scheduled_open_at"
            v-mask="'##/##/#### ##:##:##'"
            :error="form.errors.scheduled_open_at"
            class="pr-6 pb-8 w-full md:w-1/4"
            input-class="text-center"
            label="Jadwal Buka (Opsional)"
            placeholder="dd/mm/yyyy HH:mm:ss" />
          <text-input
            v-model="form.scheduled_close_at"
            v-mask="'##/##/#### ##:##:##'"
            :error="form.errors.scheduled_close_at"
            class="pr-6 pb-8 w-full md:w-1/4"
            input-class="text-center"
            label="Jadwal Tutup (Opsional)"
            placeholder="dd/mm/yyyy HH:mm:ss" />
          <div class="pr-6 pb-8 w-full">
            <label class="form-label">Konten</label>
            <SimpleEditor
              v-model="form.content"
              class="mt-1" />
            <div v-if="form.errors.content" class="form-error">
              {{ form.errors.content }}
            </div>
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex flex-wrap items-center justify-end space-x-3">
          <button
            type="button"
            @click="handleCancel"
            class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
            Batal
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Buat Pengumuman
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue2'
import { Link, useForm } from '@inertiajs/vue2'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import SimpleEditor from '@/Shared/SimpleEditor'

export default {
  components: {
    Head,
    'inertia-link': Link,
    TextInput,
    SelectInput,
    LoadingButton,
    SimpleEditor,
  },

  layout: Layout,

  data () {
    return {
      title: 'Buat Pengumuman',
      form: useForm({
        title: null,
        content: null,
        portal_status: 'open',
        is_active: false,
        scheduled_open_at: null,
        scheduled_close_at: null,
      }),
    }
  },

  methods: {
    submit () {
      this.form.post(this.route('admin.portal-announcements.store'))
    },
    handleCancel () {
      this.$inertia.visit(this.route('admin.portal-announcements.index'))
    },
  },
}
</script>
